import { useTranslation } from 'react-i18next';
import TextEditor from 'ui/TextEditor/TextEditor';

const inlineEditorStyle = {
    '& .node-fraction': {
        display: 'inline-flex',
        flexDirection: 'column',
        verticalAlign: 'middle',
        alignItems: 'center',
        lineHeight: '1.2', // Force une hauteur de ligne constante
    },

    '& .node-fraction p': {
        margin: '0.25em', // Supprime les marges automatiques de Tiptap
        padding: '0.25em',
        textAlign: 'center',
    },
};

type Props = {
    canEdit: boolean;
    isEditable: boolean;
    content: string;
    onSave: (value: string) => void;
    mentionType?: 'field' | 'none';
};

const DataCatalogTextEditor = ({
    canEdit,
    isEditable,
    content,
    onSave,
    mentionType = 'field',
}: Props) => {
    const { t } = useTranslation();
    return (
        <TextEditor
            isEditable={isEditable}
            content={content}
            canEdit={canEdit}
            onSave={onSave}
            module="decision"
            mentionType={mentionType}
            deactivateAutoSave
            sx={inlineEditorStyle}
            emptyTextPlaceholder={
                canEdit
                    ? t('dataCatalog.detailPanel.emptyDescription')
                    : undefined
            }
        />
    );
};

export default DataCatalogTextEditor;
